import React, { useState } from "react";
import { JaaSMeeting } from "@jitsi/react-sdk";
import Permission from "./Permission";
const Jitsi = ({ data }) => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {data.logo == null && (
        <a href="https://www.studifysuccess.com" target="_blank">
          <img src="logo.png" alt="logo" className="logo" />
        </a>
      )}
      <JaaSMeeting
        appId={data?.appId}
        roomName={data?.roomName}
        jwt={data?.token}
        userInfo={{ displayName: data?.name, email: data?.name }}
        configOverwrite={{
          prejoinPageEnabled: false,
          startWithAudioMuted: true,
          startWithVideoMuted: true,
          enableWelcomePage: false,
          enableLobbyChat: true,
          disableInviteFunctions: true,
          toolbarConfig: {
            alwaysVisible: true,
          },
          disablePolls: true,
          disableReactions: false,
          disableSelfView: false,
          maxFullResolutionParticipants: 2,
          disableChatSmileys: false,
          // giphy: {
          //     // Whether the feature is enabled or not.
          //     enabled: false,
          // }
          // liveStreaming: {
          //    // Whether to enable live streaming or not.
          //    enabled: false,
          //    // Terms link
          //    termsLink: 'https://www.youtube.com/t/terms',
          //    // Data privacy link
          //    dataPrivacyLink: 'https://policies.google.com/privacy',
          //    // RegExp string that validates the stream key input field
          //    validatorRegExpString: '^(?:[a-zA-Z0-9]{4}(?:-(?!$)|$)){4}',
          //    // Documentation reference for the live streaming feature.
          //    helpLink: 'https://jitsi.org/live'
          // },
          breakoutRooms: {
            // Hides the add breakout room button. This replaces `hideAddRoomButton`.
            hideAddRoomButton: true,
            // Hides the auto assign participants button.
            hideAutoAssignButton: true,
            // Hides the join breakout room button.
            hideJoinRoomButton: true,
          },
          filmstrip: {
            // Disable the vertical/horizontal filmstrip.
            disabled: true,
            // Disables user resizable filmstrip. Also, allows configuration of the filmstrip
            // (width, tiles aspect ratios) through the interfaceConfig options.
            disableResizable: false,

            // Disables the stage filmstrip
            // (displaying multiple participants on stage besides the vertical filmstrip)
            disableStageFilmstrip: false,

            // Default number of participants that can be displayed on stage.
            // The user can change this in settings. Number must be between 1 and 6.
            stageFilmstripParticipants: 1,

            // Disables the top panel (only shown when a user is sharing their screen).
            disableTopPanel: false,

            // The minimum number of participants that must be in the call for
            // the top panel layout to be used.
            minParticipantCountForTopPanel: 50,
          },
        }}
        interfaceConfigOverwrite={{
          TOOLBAR_BUTTONS:
            data?.token == undefined
              ? [
                  "microphone",
                  "camera",
                  "desktop",
                  "fullscreen",
                  "chat",
                  "raisehand",
                  "hangup",
                  "tileview",
                  "participants-pane",
                  "prejoin-page",
                ]
              : [
                  "camera",
                  "chat",
                  "closedcaptions",
                  "desktop",
                  "download",
                  "embedmeeting",
                  "etherpad",
                  // "feedback",
                  // "filmstrip",
                  "fullscreen",
                  "hangup",
                  // "help",
                  "highlight",
                  // "invite",
                  // "linktosalesforce",
                  // "livestreaming",
                  "microphone",
                  "noisesuppression",
                  "participants-pane",
                  "profile",
                  "raisehand",
                  // "recording",
                  "security",
                  "select-background",
                  "settings",
                  "shareaudio",
                  "sharedvideo",
                  "shortcuts",
                  "stats",
                  "tileview",
                  "toggle-camera",
                  // "videoquality",
                  "whiteboard",
                ],
          //   SHOW_JITSI_WATERMARK: false,
          //   SHOW_BRAND_WATERMARK: false,
          //   SHOW_POWERED_BY: false,
          CONNECTION_INDICATOR_DISABLED: true,
          CLOSE_PAGE_ENABLED: true,
          SHOW_CHROME_EXTENSION_BANNER: false,
          // DEFAULT_BACKGROUND: "#cb6d6d",
          HIDE_INVITE_MORE_HEADER: true,
          // BRAND_WATERMARK_LINK: "",
          // DEFAULT_WELCOME_PAGE_LOGO_URL: "images/watermark.svg",
          SHOW_BRAND_WATERMARK: false,
        }}
        onApiReady={(apiInstance) => {}}
        onReadyToClose={() => {
          window.location.replace("/feedback");
        }}
        getIFrameRef={(iframe) => {
          iframe.style.height = "100dvh";
          iframe.style.width = "100%";
        }}
      />
    </div>
  );
};

const Room = ({ data }) => {
  const [permisson, setPermission] = useState(true);

  return permisson ? (
    <Jitsi data={data} />
  ) : (
    <Permission setPermission={setPermission} />
  );
};

export default Room;
